import { Component, Input } from '@angular/core';
import { GermplasmDto } from '../../shared/germplasm/model/germplasm.model';
import { GermplasmDetailsUrlService } from '../../shared/germplasm/service/germplasm-details.url.service';
import { VIEW_NAMES_PERMISSION } from '../../shared/auth/permissions';
import { MAX_NAME_DISPLAY_SIZE } from '../../app.constants';

@Component({
    selector: 'jhi-germplasm-table',
    templateUrl: './germplasm-table.component.html'
})
export class GermplasmTableComponent {

    @Input() germplasmList: GermplasmDto[] = [];
    MAX_NAME_DISPLAY_SIZE = MAX_NAME_DISPLAY_SIZE;
    VIEW_NAMES_PERMISSION = VIEW_NAMES_PERMISSION;

    constructor(public germplasmDetailsUrlService: GermplasmDetailsUrlService) {
    }
}
